import React, { Component } from 'react'
import cover from '../imgs/zine6/cover.PNG'
import pg1 from '../imgs/zine6/1.PNG'
import pg2 from '../imgs/zine6/2.PNG'
import pg3 from '../imgs/zine6/3.PNG'
import pg4 from '../imgs/zine6/4.PNG'
import pg5 from '../imgs/zine6/5.PNG'
import pg6 from '../imgs/zine6/6.PNG'
import pg7 from '../imgs/zine6/7.PNG'
import pg8 from '../imgs/zine6/8.PNG'
import pg9 from '../imgs/zine6/9.PNG'
import pg10 from '../imgs/zine6/10.PNG'
import pg11 from '../imgs/zine6/11.PNG'
import pg12 from '../imgs/zine6/12.PNG'
import back from '../imgs/zine6/end.PNG'

var pageStyle = {
  width: "25em"
}

export default class Six extends Component {
  render() {
    return (
      <div>
        <div style={{display: "flex", flexFlow: "row wrap", justifyContent: "center", alignItems: "center", backgroundColor: "#FFCE73", background: "white url(https://gdurl.com/zUud) repeat fixed top", backgroundSize: "100vw", overflowX: "hidden"}}>
          {/* <img style={{width: "20em", boxShadow: "-10px 10px #c266aa", margin: "3em 0"}} src="https://gdurl.com/Yv6I" alt="HMMMM 6" /> */}
          <div style={{backgroundColor: "white", paddingBottom: "2em", marginTop: '3em'}}>
            <img style={pageStyle} src={cover} alt="HMMMM 1" />
            <img style={pageStyle} src={pg1} alt="HMMMM 1" />
            <img style={pageStyle} src={pg2} alt="HMMMM 1" />
            <img style={pageStyle} src={pg3} alt="HMMMM 1" />
            <img style={pageStyle} src={pg4} alt="HMMMM 1" />
            <img style={pageStyle} src={pg5} alt="HMMMM 1" />
            <img style={pageStyle} src={pg6} alt="HMMMM 1" />
            <img style={pageStyle} src={pg7} alt="HMMMM 1" />
            <img style={pageStyle} src={pg8} alt="HMMMM 1" />
            <img style={pageStyle} src={pg9} alt="HMMMM 1" />
            <img style={pageStyle} src={pg10} alt="HMMMM 1" />
            <img style={pageStyle} src={pg11} alt="HMMMM 1" />
            <img style={pageStyle} src={pg12} alt="HMMMM 1" />
            <img style={pageStyle} src={back} alt="HMMMM 1" />
          </div>
        </div>
      </div>
    )
  }
}
